/** Ruta de la app → users_modules.module_key */
export function requiredModuleKeyForPath(pathname: string): string | null {
  if (pathname.startsWith('/dashboard')) return 'dashboards';
  if (
    pathname.startsWith('/streams') ||
    pathname.startsWith('/recordings') ||
    pathname.startsWith('/analytics') ||
    pathname.startsWith('/download-certificates')
  ) {
    return 'xtam_vms';
  }
  if (pathname.startsWith('/map')) return 'mapa';
  if (pathname.startsWith('/admin/button-alerts')) return 'alarmas';
  if (pathname.startsWith('/admin/public-address')) return 'alarmas';
  if (
    pathname.startsWith('/admin/sites') ||
    pathname.startsWith('/admin/historic') ||
    pathname.startsWith('/admin/miniiot') ||
    pathname.startsWith('/admin/inventory')
  ) {
    return 'administracion';
  }
  if (pathname.startsWith('/cameras')) return 'administracion';
  if (pathname.startsWith('/security/')) return 'seguridad';
  return null;
}

/**
 * Ruta → permiso granular `moduleKey:actionKey`.
 * null = la ruta no exige submódulo (basta con acceso al módulo o no aplica RBAC por módulo).
 */
export function requiredActionGrantForPath(pathname: string): string | null {
  if (pathname.startsWith('/streams')) return 'xtam_vms:streaming';
  if (pathname.startsWith('/recordings')) return 'xtam_vms:recordings_preview';
  if (pathname.startsWith('/download-certificates')) return 'xtam_vms:recordings_download';
  if (pathname.startsWith('/analytics')) return 'xtam_vms:analytics';
  if (pathname.startsWith('/admin/button-alerts')) return 'alarmas:alerts_buttons_eu';
  if (pathname.startsWith('/admin/public-address')) return 'alarmas:alerts_buttons_eu';
  if (pathname.startsWith('/admin/sites')) return 'administracion:sites';
  if (pathname.startsWith('/admin/historic')) return 'administracion:history';
  if (pathname.startsWith('/admin/miniiot')) return 'administracion:miniiot';
  if (pathname.startsWith('/admin/inventory')) return 'administracion:inventory';
  if (pathname.startsWith('/cameras')) return 'administracion:cameras';
  if (pathname.startsWith('/security/roles')) return 'seguridad:roles';
  if (pathname.startsWith('/security/users')) return 'seguridad:users';
  if (pathname.startsWith('/security/audit')) return 'seguridad:users';
  return null;
}
